import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, withModifiers as _withModifiers, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, TransitionGroup as _TransitionGroup, withCtx as _withCtx, Transition as _Transition } from "vue"

const _hoisted_1 = { class: "order" }
const _hoisted_2 = { class: "order-header" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = {
  key: 0,
  class: "order__buttons"
}
const _hoisted_5 = {
  key: 0,
  class: "suggested-content"
}
const _hoisted_6 = { key: 1 }
const _hoisted_7 = ["onClick"]
const _hoisted_8 = { class: "order__info__name" }
const _hoisted_9 = ["onClick"]
const _hoisted_10 = {
  key: 0,
  class: "order__modal__header"
}
const _hoisted_11 = /*#__PURE__*/_createElementVNode("span", { class: "icon-cancel" }, null, -1)
const _hoisted_12 = [
  _hoisted_11
]
const _hoisted_13 = { class: "order__modal__inner" }
const _hoisted_14 = { class: "order__content" }
const _hoisted_15 = ["data-index"]
const _hoisted_16 = ["data-orders", "disabled"]
const _hoisted_17 = {
  key: 1,
  class: "order__content__text",
  "data-orders": "0"
}
const _hoisted_18 = { class: "order__pay" }
const _hoisted_19 = {
  key: 0,
  class: "order-item total-order"
}
const _hoisted_20 = ["updating"]
const _hoisted_21 = ["onClick", "disabled"]

import { reactive, onMounted, computed } from 'vue';
    import { watch } from 'vue';
    import router from '../router';
    import gsap from 'gsap'
    import { CartStore } from '@/stores/cart';
    import { MenuStore } from '@/stores/menu';
    import { AppStore } from '@/stores/app';
    import { useI18n } from 'vue-i18n'
    import OrderItem from '@/components/OrderItem.vue';
    import OrderShopInfo from '@/components/OrderShopInfo.vue';
    import ConfirmPopup from '@/components/ConfirmPopup.vue';
    import { useEmitter } from '@/composables/useEmitter';


    interface State {
        showOrderInfo: boolean,
        showCancelModal: boolean,
        isCounting: boolean,
        currency: string,
    }
    interface Props {
        disabled?: boolean
    }

    /* Props */
    //const props =
    
export default /*#__PURE__*/_defineComponent({
  __name: 'OrderComponent',
  props: {
    disabled: { type: Boolean }
  },
  setup(__props: any) {


    /* imports */
    const { t } = useI18n();

    const cartStore = CartStore();
    const menuStore = MenuStore();
    const appStore = AppStore();
    const emitter = useEmitter();


    /* interface */
    

    /* Reactive */
    const tweened = reactive({
        number: 0
    })

    const state = reactive<State>({
        showOrderInfo: false,
        showCancelModal: false,
        isCounting: false,
        currency: menuStore.getCurrency().symbol
    });

    /* ref */

    /* computed */
    const transitionName = computed<string>(() => {
        return appStore.state.isSmallScreen ? "from-bottom" : "fade-in-out";
    });

    const disabled = computed<boolean>(() => {
        return cartStore.state.disabled;
    });

    const addBtnText = (): string => {
        return !cartStore.state.editMode ? t("button.add") : t("button.done");
    }

    const suggestedBtnText = computed<string>(() => cartStore.state.hasSelectedSuggestions ? t("button.done") : t("button.noThanks"));

    const totalPrice = computed<number>(() => {
        return cartStore.totalPrice;
    });

    /* Refs */

    /* Functions */

    //Animations for orderItems.
    const onBeforeEnter = (el: HTMLElement) => {
        el.style.opacity = '0';
        el.style.height = '0';
    }
    const onEnter = (el: HTMLElement, done: any) => {
        gsap.to(el, {
            opacity: 1,
            height: 'auto',
            delay: Number(el.dataset.index) * 0.15,
            onComplete: done
        })
    }

    const onLeave = (el: HTMLElement, done: any) => {
        gsap.to(el, {
            opacity: 0,
            height: 0,
            delay: Number(el.dataset.index) * 0.15,
            onComplete: done
        })
    }

    // Will trigger event in components and views
    const addToOrder = () => emitter.emit('add-order');

    const toggleShowOrder = (): void => {
        cartStore.state.showOrderInfo = !cartStore.state.showOrderInfo;
    }

    const onCancel = () => cartStore.state.items.length ? toggleCancelModal() : cancelOrder(true);

    const toggleCancelModal = () => {
        state.showCancelModal = !state.showCancelModal;
    }

    const cancelOrder = (value: boolean) => {

        state.showCancelModal = false; // Hide cancel order question (popup)

        if (value) {
            cartStore.clear(true); // Clear store
            router.push({ name: 'home' }); // Send user to to homepage
        }
    }

    const pay = () => {
        router.push({ 
            name: 'checkoutPage',
            params: {
                shopId: cartStore.state.shopId    
            }             
        }); // Send user to Checkout page
    }

    /* Watch */

    //Add animation when total price changes
    watch(
        totalPrice,
        (n) => {
            gsap.to(tweened, {
                duration: 1, number: Number(n) || 0,
                onStart: () => {
                    state.isCounting = true;
                },
                onComplete: () => {
                    state.isCounting = false;
                }
            })
        }
    )

    /* Lifecycle Hooks */
    onMounted(() => {
        if (cartStore.state.items?.length) {
            tweened.number = cartStore.totalPrice;
        }
    });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_Transition, { name: _unref(transitionName) }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            (_unref(appStore).state.isLargeScreen)
              ? (_openBlock(), _createElementBlock("h2", _hoisted_3, _toDisplayString(_unref(t)("order.header")), 1))
              : _createCommentVNode("", true)
          ]),
          (_unref(appStore).state.isSmallScreen)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                (_unref(cartStore).state.showAddItemButton)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 0,
                      class: "btn order__add",
                      onClick: addToOrder
                    }, [
                      (_unref(appStore).state.currentPage === 'suggestedArticlesPage')
                        ? (_openBlock(), _createElementBlock("span", _hoisted_5, [
                            _createElementVNode("span", null, _toDisplayString(_unref(suggestedBtnText)), 1)
                          ]))
                        : (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(addBtnText()), 1))
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("button", {
                  class: _normalizeClass(["btn order__info", {'btn--secondary': _unref(cartStore).state.showAddItemButton}]),
                  onClick: _withModifiers(toggleShowOrder, ["prevent","stop"])
                }, [
                  _createElementVNode("div", _hoisted_8, _toDisplayString(_unref(t)("order.header")), 1),
                  _createElementVNode("div", {
                    class: _normalizeClass(["order__info__price", {'price--update': state.isCounting}])
                  }, _toDisplayString(tweened.number.toFixed(0)) + _toDisplayString(state.currency), 3)
                ], 10, _hoisted_7)
              ]))
            : _createCommentVNode("", true),
          _createVNode(_Transition, { name: _unref(transitionName) }, {
            default: _withCtx(() => [
              ((_unref(cartStore).state.showOrderInfo || _unref(appStore).state.isLargeScreen))
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    class: "order__modal",
                    onClick: _withModifiers(toggleShowOrder, ["self"])
                  }, [
                    (_unref(appStore).state.isSmallScreen)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                          _createElementVNode("button", {
                            class: "btn--close",
                            onClick: toggleShowOrder
                          }, _hoisted_12),
                          _createElementVNode("h2", null, _toDisplayString(_unref(t)("order.header")), 1)
                        ]))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_13, [
                      _createVNode(OrderShopInfo),
                      _createElementVNode("div", _hoisted_14, [
                        _createVNode(_TransitionGroup, {
                          tag: "ol",
                          css: false,
                          onBeforeEnter: onBeforeEnter,
                          onEnter: onEnter,
                          onLeave: onLeave
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(cartStore).state.items, (item, index) => {
                              return (_openBlock(), _createElementBlock("li", {
                                key: item.id,
                                "data-index": index
                              }, [
                                _createVNode(OrderItem, {
                                  item: item,
                                  editable: true,
                                  curency: state.currency,
                                  disabled: _unref(disabled)
                                }, null, 8, ["item", "curency", "disabled"])
                              ], 8, _hoisted_15))
                            }), 128))
                          ]),
                          _: 1
                        })
                      ]),
                      (_unref(cartStore).state.items.length)
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 0,
                            class: "order__content__text",
                            "data-orders": _unref(cartStore).state.items.length,
                            disabled: _unref(disabled)
                          }, [
                            _createElementVNode("span", null, _toDisplayString(_unref(t)("order.infoText")), 1),
                            _createElementVNode("span", null, _toDisplayString(_unref(t)("order.infoText2")), 1)
                          ], 8, _hoisted_16))
                        : _createCommentVNode("", true),
                      (!_unref(cartStore).state.items.length)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                            _createElementVNode("span", null, _toDisplayString(_unref(t)("order.emptyInfoText")), 1)
                          ]))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", _hoisted_18, [
                        (_unref(cartStore).state.items.length)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                              _createElementVNode("span", null, _toDisplayString(_unref(t)("label.total")), 1),
                              _createElementVNode("span", {
                                class: "order-item__price",
                                updating: state.isCounting
                              }, _toDisplayString(tweened.number.toFixed(0)) + _toDisplayString(state.currency), 9, _hoisted_20)
                            ]))
                          : _createCommentVNode("", true),
                        (_unref(cartStore).state.items.length)
                          ? (_openBlock(), _createElementBlock("button", {
                              key: 1,
                              class: "btn btn--pay",
                              onClick: _withModifiers(pay, ["prevent"]),
                              disabled: _unref(disabled)
                            }, _toDisplayString(_unref(t)("button.pay")), 9, _hoisted_21))
                          : _createCommentVNode("", true),
                        (_unref(cartStore).state.items.length)
                          ? (_openBlock(), _createElementBlock("button", {
                              key: 2,
                              class: "btn btn--secondary cancel-order",
                              onClick: onCancel
                            }, _toDisplayString(_unref(t)("button.cancelOrder")), 1))
                          : _createCommentVNode("", true)
                      ])
                    ])
                  ], 8, _hoisted_9))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["name"])
        ])
      ]),
      _: 1
    }, 8, ["name"]),
    _createVNode(ConfirmPopup, {
      heading: "cancel.order.header",
      text: "cancel.order.description",
      okButton: "cancel.order.confirm",
      cancelButton: "cancel.order.cancel",
      show: state.showCancelModal,
      onOnAnswer: cancelOrder
    }, null, 8, ["show"])
  ], 64))
}
}

})